import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import WebsiteImage from 'components/WebsiteImage';
import PlayButton from 'components/Core/WistiaVideo/components/PlayButton';
import { ThumbnailPopoverContainer } from './styles';
import WistiaVideoModal from '../components/WistiaVideoModal';

const ThumbnailPopover = ({ thumbnail, thumbnailLoading }) => (
  <ThumbnailPopoverContainer className="wistia-video--wrapper">
    <PlayButton alwaysShow />
    <WebsiteImage {...(thumbnail?.image || thumbnail)} loading={thumbnailLoading} />
    <WistiaVideoModal />
  </ThumbnailPopoverContainer>
);

export default WithWistiaContext(ThumbnailPopover);
